// extracted by css-extract-rspack-plugin
export default {"wrapper":"X3ObO6r1o4wnuh2r","inner":"UUMpKALJ0kKQZJFw","left":"j1eb9LoASYAw542f","right":"i7bAwKGjK2gKl5mb"};